(() => {
  'use strict';
  const form = document.querySelector('[data-lt-cart]');
  const box = form && form.querySelector('[data-lt-invoice]');
  if (!box || box.dataset.ready) return;
  box.dataset.ready = 'true';
  const fields = [...box.querySelectorAll('[data-lt-field]')];
  const radios = [...box.querySelectorAll('input[type=radio]')];
  const clears = [...box.querySelectorAll('[data-lt-clear]')];
  const error = box.querySelector('[data-lt-error]');
  const checkout = form.querySelector('[data-lt-checkout]');
  const rut = box.querySelector('[data-lt-field=rut]');
  const invoice = () => radios.some(r => r.checked && r.value === 'Sí');

  function normalizedRut(value) {
    const clean = value.replace(/[.\s-]/g, '').toUpperCase();
    if (!/^\d{7,8}[0-9K]$/.test(clean)) return null;
    const body = clean.slice(0, -1);
    if (Number(body) === 0) return null;
    let sum = 0, factor = 2;
    for (let i = body.length - 1; i >= 0; i--) {
      sum += Number(body[i]) * factor;
      factor = factor === 7 ? 2 : factor + 1;
    }
    const remainder = 11 - sum % 11;
    const dv = remainder === 11 ? '0' : remainder === 10 ? 'K' : String(remainder);
    return dv === clean.slice(-1) ? `${Number(body)}-${dv}` : null;
  }
  function sync() {
    const wants = invoice();
    box.querySelector('[data-lt-fields]').hidden = !wants;
    fields.forEach(field => { field.disabled = !wants; field.required = wants; field.setCustomValidity(''); });
    clears.forEach(field => { field.disabled = wants; });
    error.hidden = true;
  }
  function valid() {
    if (!invoice()) return true;
    fields.forEach(field => {
      field.value = field.value.trim();
      field.setCustomValidity(field.value ? '' : 'Completa este dato para solicitar factura.');
    });
    const normalized = normalizedRut(rut.value);
    if (normalized) rut.value = normalized;
    else rut.setCustomValidity('Ingresa un RUT válido, incluyendo su dígito verificador.');
    const invalid = fields.find(field => !field.checkValidity());
    error.hidden = !invalid;
    if (invalid) {
      error.textContent = 'Revisa los datos de facturación antes de continuar.';
      invalid.focus();
      invalid.reportValidity();
      checkout.classList.remove('btn--loading');
      return false;
    }
    return true;
  }
  radios.forEach(radio => radio.addEventListener('change', sync));
  fields.forEach(field => field.addEventListener('input', () => { field.setCustomValidity(''); error.hidden = true; }));
  // Capture runs before Impulse's loading indicator and terms handler.
  form.addEventListener('click', event => {
    if (event.target.closest('[data-lt-checkout]') && !valid()) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  form.addEventListener('submit', event => {
    // Updating quantities is allowed with incomplete invoice data.
    if (event.submitter && event.submitter.name === 'update') return;
    const terms = form.querySelector('#CartPageAgree');
    if (!valid() || (terms && !terms.checked)) {
      event.preventDefault();
      checkout.classList.remove('btn--loading');
      if (terms && !terms.checked) {
        error.textContent = 'Acepta los términos y condiciones antes de continuar.';
        error.hidden = false;
        terms.focus();
      }
    }
  });
  sync();
  checkout.disabled = false;
})();
